<script>
import messages from "../../mixins/messages";
import toasts from "../../mixins/toasts";

export default Vue.extend({
  mixins: [messages, toasts],
  data() {
    return {
      modified: false,
      survey: null
    };
  },
  mounted() {
    this.modified = false;
  },
  methods: {
    update(survey) {
      this.modified = true;
      this.survey = survey;
    },
    submit(scopeModified) {
        if (!this.modified) {
            return;
        }

        if (this.survey.published && scopeModified) {
            this.$dialog.confirm({
                title: "Изменение списка участников",
                message:
                    `Вы собираетесь изменить список участников у <b>уже ` +
                    `${this.survey.is_quiz ? 'опубликованного</b> теста' : 'опубликованной</b> анкеты'}.<br>` +
                    `Если вы убрали какую-либо из групп участников, для которых уже ` +
                    `${this.survey.is_quiz ? 'опубликован тест' : 'опубликована анкета'}, то данные участники ` +
                    `<b>не смогут завершить</b> заполнение ${this.survey.is_quiz ? 'теста' : 'анкеты'}.`,
                confirmText: "Продолжить",
                cancelText: "Отмена",
                type: "is-warning",
                hasIcon: true,
                onConfirm: () => {
                    this.sendSubmitRequest()
                }
            })
        } else {
            this.sendSubmitRequest()
        }
    },
    sendSubmitRequest() {
      let loading = this.$loading.open();
      axios
        .put(`/api/surveys/${this.survey.id}`, this.survey)
        .then(response => {
          loading.close();
          this.modified = false;
          this.survey = response.data;
          this.$refs.form.update(this.survey);
          this.toast(
            "success",
            this.survey.is_quiz
              ? "Тест был успешно сохранен"
              : "Анкета была успешно сохранена"
          );
        })
        .catch(error => {
          loading.close();
          switch (error.response.status) {
            case 422: {
              let errors = error.response.data.errors;
              let key = _.first(_.keys(errors));
              this.toast("warning", _.first(errors[key]));
              break;
            }
            default: {
              this.modified = true;
              this.toast("error", "@unexpected", error);
              break;
            }
          }
        });
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/surveys/Edit.vue